import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import {
    FaBell,
    FaTimes,
    FaCheckCircle,
    FaBellSlash,
    FaExclamationTriangle,
} from 'react-icons/fa';
import './NotificationPermissionModal.css';

const NotificationPermissionModal = ({
    show,
    onClose,
    onAllow,
    onBlock,
    loading = false,
    resultMessage = null,
    resultType = null,
}) => {
    if (!show) return null;

    const renderBadgeIcon = () => {
        if (resultType === 'success') {
            return <FaCheckCircle size={18} />;
        }
        if (resultType === 'blocked') {
            return <FaBellSlash size={18} />;
        }
        if (resultType === 'warning') {
            return <FaExclamationTriangle size={18} />;
        }
        return <FaBell size={18} />;
    };

    return (
        <div className="notification-permission-backdrop" role="presentation">
        <div
            className={`notification-floating-card ${resultMessage ? 'has-result' : ''}`}
            role="dialog"
            aria-modal="true"
            aria-label="Notification Permission Prompt"
        >
            <div className="notification-card-header">
                <div
                    className={`notification-bell-badge ${resultType ? `badge-${resultType}` : ''}`}
                    aria-hidden="true"
                >
                    {renderBadgeIcon()}
                </div>
                <div
                    className="notification-card-text"
                    role={resultMessage ? 'status' : undefined}
                    aria-live={resultMessage ? 'polite' : undefined}
                >
                    {resultMessage || 'Allow notifications to receive important updates.'}
                </div>
                <button
                    type="button"
                    className="notification-card-close"
                    onClick={onClose}
                    aria-label="Close"
                    disabled={loading}
                >
                    <FaTimes size={13} />
                </button>
            </div>

            {!resultMessage && (
                <div className="notification-card-actions">
                    <Button
                        variant="outline-secondary"
                        className="btn-card-block"
                        onClick={onBlock}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-1"
                                />
                                Block
                            </>
                        ) : (
                            'Block'
                        )}
                    </Button>
                    <Button
                        variant="primary"
                        className="btn-card-allow"
                        onClick={onAllow}
                        disabled={loading}
                    >
                        Allow
                    </Button>
                </div>
            )}
        </div>
        </div>
    );
};

NotificationPermissionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAllow: PropTypes.func.isRequired,
    onBlock: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    resultMessage: PropTypes.string,
    resultType: PropTypes.string,
};

export default NotificationPermissionModal;
